var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsFilterPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_13741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6517 15.5517L10.6597 15.5564C11.3678 16.0072 12.2085 16.203 13.0429 16.1115C13.8773 16.02 14.6555 15.6466 15.2491 15.0531L15.7651 14.5371C15.9955 14.3063 16.125 13.9935 16.125 13.6674C16.125 13.3413 15.9955 13.0285 15.7651 12.7977L13.5911 10.6251C13.3603 10.3946 13.0475 10.2652 12.7214 10.2652C12.3953 10.2652 12.0825 10.3946 11.8517 10.6251V10.6251C11.7376 10.7393 11.6021 10.83 11.4529 10.8918C11.3038 10.9537 11.1439 10.9855 10.9824 10.9855C10.8209 10.9855 10.661 10.9537 10.5118 10.8918C10.3627 10.83 10.2272 10.7393 10.1131 10.6251L6.63439 7.14574C6.40393 6.91499 6.27448 6.6022 6.27448 6.27608C6.27448 5.94995 6.40393 5.63716 6.63439 5.40641V5.40641C6.74864 5.2923 6.83928 5.15678 6.90112 5.00762C6.96296 4.85845 6.99479 4.69856 6.99479 4.53708C6.99479 4.3756 6.96296 4.21571 6.90112 4.06654C6.83928 3.91737 6.74864 3.78186 6.63439 3.66774L4.46105 1.49174C4.2303 1.26128 3.91751 1.13184 3.59139 1.13184C3.26526 1.13184 2.95247 1.26128 2.72172 1.49174L2.20572 2.00774C1.61227 2.60133 1.23893 3.37951 1.1473 4.21385C1.05567 5.04819 1.25124 5.88885 1.70172 6.59708L1.70705 6.60508C4.08933 10.1316 7.1257 13.1687 10.6517 15.5517V15.5517Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_13741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.625 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsFilterPhone);
export default __webpack_public_path__ + "static/media/ContactsFilterPhone.8a24780d07a178eb60b570e832bfaa36.svg";
export { ForwardRef as ReactComponent };